// Zaplanowane wiadomości (30.10.2026): karta oferty z wiadomościami wysyłanymi automatycznie
// do każdej rezerwacji. Panel: components/Propiedades/ScheduledMessagesPanel.vue
export const scheduledMessages = {
  head: {
    title: "Zaplanowane wiadomości",
    sub: "Co otrzymuje gość, od rezerwacji aż do czasu po wyjeździe.",
    new: "Nowa wiadomość",
  },
  loadError: "Nie udało się wczytać wiadomości.",
  retry: "Spróbuj ponownie",
  cancel: "Anuluj",
  noName: "Bez nazwy",
  tabs: { mensajes: "Wiadomości", proximos: "Najbliższe wysyłki", historial: "Historia" },
  stages: { antes: "Przed przyjazdem", durante: "W trakcie pobytu", despues: "Po wyjeździe" },
  when: {
    entrada: "zameldowania",
    salida: "wymeldowania",
    sameDay: "W dniu {momento}, o {hora}",
    before: "{n} dzień przed datą {momento}, o {hora} | {n} dni przed datą {momento}, o {hora}",
    after: "{n} dzień po dacie {momento}, o {hora} | {n} dni po dacie {momento}, o {hora}",
  },
  channels: { email: "E-mail", whatsapp: "WhatsApp", ota: "OTA" },
  origins: { all: "Wszystkie", directa: "Bezpośrednie", booking: "Booking", airbnb: "Airbnb", expedia: "Expedia", otras: "Inne kanały" },
  status: {
    pendiente: "W toku",
    enviado: "Wysłano",
    en_cola: "Czeka na akceptację",
    fallo: "Nie wysłano",
    sin_contacto: "Brak danych kontaktowych",
    cancelado: "Anulowano",
  },
  errors: {
    canal_reserva_no_encontrada: "Kanał nie znalazł tej rezerwacji. Mogła już nie istnieć lub jej czat jest niedostępny.",
    canal_sin_permiso: "Kanał nie zezwolił na wysyłkę. Sprawdź połączenie tego obiektu.",
    canal_no_responde: "Kanał nie odpowiedział w tym momencie.",
    canal_rechazo: "Kanał nie przyjął wiadomości.",
    whatsapp_numero_invalido: "Numer jest nieprawidłowy lub nie ma WhatsAppa.",
    whatsapp_rechazo: "WhatsApp nie przyjął wiadomości.",
    correo_fallido: "Nie udało się dostarczyć e-maila.",
    envio_fallido: "Nie udało się ukończyć wysyłki.",
    envio_interrumpido: "Wysyłka została przerwana przed zakończeniem.",
    sin_telefono: "Rezerwacja nie ma prawidłowego telefonu.",
    sin_correo: "Rezerwacja nie ma własnego e-maila. Adres z OTA to alias.",
    sin_chat_ota: "Rezerwacja nie pochodzi z OTA z czatem.",
    mensaje_borrado: "Wiadomość usunięto przed wysyłką.",
    mensaje_desactivado: "Wiadomość wyłączono przed wysyłką.",
    reserva_cancelada: "Rezerwację anulowano przed wysyłką.",
    alojamiento_no_existe: "Obiekt już nie istnieje.",
    mensaje_vacio: "Wiadomość okazała się pusta.",
    ya_no_tocaba: "Gdy gość zaakceptował, doręczenie nie było już właściwe.",
  },
  unitScope: {
    sub: "Tylko dla: {name}. Wiadomości z oferty też tu trafiają, chyba że je tutaj zmienisz lub wyłączysz.",
    inherited: "Z oferty",
    replaces: "Zastępuje wiadomość z oferty",
    removed: "Wyłączona w tej jednostce",
    offInListing: "Wyłączona w ofercie",
    differentIn: "Inna w: {names}",
    customize: "Zmień tylko w tej jednostce",
    turnOff: "Nie wysyłaj „{name}” w tej jednostce",
    confirmRestore: "Usunąć? Znów będzie wychodzić wiadomość z oferty.",
    ownUnits: "Te jednostki mają też własne wiadomości: {names}. Edytuje się je w każdej jednostce.",
    replaceHint: "Ta sama nazwa co w ofercie: w tej jednostce zostanie wysłana ta wiadomość zamiast tamtej.",
  },
  clone: {
    button: "Klonuj",
    rowAction: "Klonuj do innego obiektu lub jednostki",
    titleAll: "Klonuj do innych obiektów lub jednostek",
    bring: "Pobierz z innej",
    bringTitle: "Pobierz wiadomości z innego obiektu lub jednostki",
    bringNoun: "jego zaplanowane wiadomości",
    titleOne: "Klonuj „{name}”",
    subtitle: "Kopiowane są tekst, kanały, filtry i pliki. Wiadomość o tej samej nazwie zostanie tam zaktualizowana, a pozostałe się nie zmienią. Aktywne wiadomości zaczną wychodzić o czasie lokalnym każdego obiektu.",
    nounAll: "zaplanowaną wiadomość | zaplanowane wiadomości ({n})",
    nounOne: "wiadomość „{name}”",
    done: "Skopiowano do {n} obiektu: nowe {nuevos}, zaktualizowane {actualizados}. | Skopiowano do obiektów ({n}): nowe {nuevos}, zaktualizowane {actualizados}.",
    skipped: {
      limite: "{names}: osiągnięto limit wiadomości, „{msgs}” się nie zmieściła.",
      archivo: "{names}: brakuje pliku z „{msgs}”. Prześlij go tutaj ponownie i sklonuj jeszcze raz.",
      error: "{names}: nie udało się skopiować „{msgs}”.",
    },
  },
  timeline: {
    booked: "Rezerwacja potwierdzona",
    bookedHint: "Jeśli rezerwacja powstanie po tym momencie, ta wiadomość nie zostanie wysłana.",
    checkin: "Dzień przyjazdu",
    checkout: "Dzień wyjazdu",
    use: "Użyj",
    add: "+ Dodaj wiadomość tutaj",
    offset: {
      sameDay: "Tego dnia",
      before: "{n} dzień przed | {n} dni przed",
      afterCheckin: "{n} dzień po | {n} dni po",
      beforeCheckout: "{n} dzień przed wyjazdem | {n} dni przed wyjazdem",
      after: "{n} dzień po | {n} dni po",
    },
  },
  presets: {
    week: { name: "Został tydzień", text: "Cześć {nombre}, już niedługo Twój pobyt w {alojamiento}. Czekamy na Ciebie {entrada}. Jeśli czegoś potrzebujesz przed przyjazdem, napisz do nas." },
    three: { name: "Przygotuj się na przyjazd", text: "Cześć {nombre}, za 3 dni witamy Cię w {alojamiento}. Zameldowanie jest od godz. {hora_entrada}. Tutaj znajdziesz wszystko o swoim pobycie: {enlace_portal}" },
    arrival: { name: "Dziś Twój przyjazd", text: "Cześć {nombre}, dziś czekamy na Ciebie w {alojamiento} od godz. {hora_entrada}. Szczęśliwej podróży!" },
    firstNight: { name: "Pierwsza noc", text: "Cześć {nombre}, mamy nadzieję, że już się zadomowiłeś w {alojamiento}. Czy wszystko w porządku? Jeśli czegoś potrzebujesz, odpowiedz na tę wiadomość." },
    lastDay: { name: "Dzień wyjazdu", text: "Cześć {nombre}, dziś kończy się Twój pobyt w {alojamiento}. Pamiętaj, że wymeldowanie jest do godz. {hora_salida}. Dziękujemy, że wybrałeś nas." },
    after: { name: "Dziękujemy za wizytę", text: "Cześć {nombre}, dziękujemy za pobyt w {alojamiento}. Mamy nadzieję wkrótce znów Cię zobaczyć." },
  },
  row: {
    files: "{n} plik | {n} plików",
    sent: "wysłane: {n} | wysłane: {n}",
    queued: "Oczekuje: {n}",
    failed: "Nie wysłano: {n}",
    duplicate: "Duplikuj",
    delete: "Usuń",
    confirmDelete: "Usunąć tę wiadomość?",
    yesDelete: "Tak, usuń",
    copyOf: "Kopia: {name}",
  },
  upcoming: {
    arrives: "Przyjazd {fecha}",
    leaves: "Wyjazd {fecha}",
    note: "Co zostanie wysłane w ciągu najbliższych 30 dni dla dzisiejszych rezerwacji. Przekreślone: tą drogą nie da się dotrzeć do tej rezerwacji.",
    empty: "Brak wysyłek zaplanowanych na najbliższe 30 dni.",
    when: "Kiedy",
    guest: "Gość",
    message: "Wiadomość",
    channels: "Kanały",
    needsCheckin: "Tylko po zakończeniu zameldowania online",
    noReach: "Brak danych dla tego kanału",
  },
  history: {
    empty: "Nie wysłano jeszcze żadnej wiadomości.",
    when: "Data",
    result: "Wynik",
    prev: "Poprzednia",
    next: "Następna",
  },
  vars: {
    nombre: "Imię",
    alojamiento: "Obiekt",
    entrada: "Data przyjazdu",
    salida: "Data wyjazdu",
    hora_entrada: "Godzina przyjazdu",
    hora_salida: "Godzina wyjazdu",
    codigo: "Kod rezerwacji",
    enlace_portal: "Link do portalu",
    enlace_tienda: "Link do sklepu",
  },
  form: {
    newTitle: "Nowa wiadomość",
    editTitle: "Edytuj wiadomość",
    name: "Nazwa wewnętrzna",
    namePh: "Np.: Przygotuj się na przyjazd",
    when: "Kiedy jest wysyłana",
    type: { antes: "Przed datą", dia: "W tym samym dniu co", despues: "Po dacie" },
    days: "Dni",
    reference: "Odniesienie",
    theDayOf: "Dzień",
    anchor: { entrada: "Zameldowania", salida: "Wymeldowania" },
    time: "Godzina",
    timeIn: "czas: {zone}",
    timeEach: "według czasu lokalnego każdego obiektu: {zones}",
    noZone: "{names}: bez kraju nie znamy czasu, więc wiadomości tam nie wyjdą. Wskaż go w lokalizacji obiektu.",
    localTime: "czas obiektu",
    duringHint: "Jeśli pobyt jest krótszy i gościa w tym dniu już nie ma, wiadomość nie zostanie wysłana.",
    channels: "Którędy jest wysyłana",
    channelShort: { email: "Tylko własny e-mail", whatsapp: "Szablon po 24 h", ota: "Czat rezerwacji" },
    previewShort: "Podgląd",
    previewFrom: "Wiadomość od",
    channelHint: {
      email: "Tylko dla rezerwacji z własnym adresem e-mail. Adres podawany przez OTA to alias, więc tam wiadomość nie dotrze.",
      whatsapp: "Jeśli minęło ponad 24 h lub nie ma rozmowy, wysyłamy szablon kontaktowy, a wiadomość dociera do gościa po jego akceptacji. Na fałszywy numer nic nie jest wysyłane.",
      ota: "Przez czat OTA, tylko dla rezerwacji z tego kanału. Pliki są wysyłane jako link.",
    },
    bookings: "Dla jakich rezerwacji",
    onlyCheckin: "Tylko jeśli gość zakończył już zameldowanie online",
    message: "Wiadomość",
    messagePh: "Napisz wiadomość, którą otrzyma gość",
    translate: "Przetłumacz na pozostałe języki",
    translating: "Tłumaczenie…",
    translated: "Przetłumaczono na pozostałe języki.",
    translatePartial: "Nie udało się przetłumaczyć języków: {n}. Sprawdź je.",
    storeHint: "Sklep wewnętrzny wymaga ukończonego zameldowania; do tego czasu link prowadzi do portalu gościa, z którego można do niego przejść. Przy sklepie zewnętrznym prowadzi bezpośrednio.",
    fallbackHint: "Wiadomość jest wysyłana w języku gościa. Jeśli nie ma w nim treści, trafia po hiszpańsku lub w pierwszym dostępnym języku.",
    subject: "Temat e-maila (opcjonalnie)",
    subjectPh: "Jeśli puste: Wiadomość od Twojego obiektu",
    files: "Zdjęcia, filmy i dokumenty",
    addFile: "Dodaj plik",
    uploading: "Przesyłanie…",
    filesHint: "Zdjęcia JPG lub PNG do {img} MB, PDF do {pdf} MB, XML do {xml} MB i filmy MP4 lub 3GP (H.264) do {video} MB. WhatsApp nie przyjmuje XML jako pliku: tam jest wysyłany jako link. W e-mailu jest załącznikiem.",
    fileTooBig: "Plik „{name}” przekracza limit {max} MB.",
    uploadError: "Nie udało się przesłać pliku.",
    active: "Aktywna",
    inactive: "Wyłączona",
    save: "Zapisz",
    saving: "Zapisywanie…",
    saved: "Wiadomość zapisana.",
    saveError: "Nie udało się zapisać. Spróbuj ponownie.",
    errName: "Nadaj wiadomości nazwę.",
    errChannels: "Wybierz co najmniej jeden kanał wysyłki.",
    errTime: "Podaj godzinę wysyłki.",
    errText: "Napisz wiadomość w co najmniej jednym języku.",
    preview: "Podgląd z przykładowymi danymi",
    previewEmpty: "Tutaj zobaczysz wiadomość.",
  },
};
